module.exports = __webpack_public_path__ + "static/img/preview-05.400f117b.webp";